import { Paper, Box, IconButton, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import { BRAND_COLOR } from "../constants";
import AnalyticsFilterItems from "./AnalyticsFilterItems";

interface AnalyticsFilterCardProps {
  data: LeadsManagementData;
}

export default function AnalyticsFilterCard({ data }: AnalyticsFilterCardProps) {
  const { refetch } = data;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: "20px 22px",
        borderRadius: 2,
        display: "flex",
        flexWrap: "wrap",
        gap: 2.25,
        alignItems: "flex-end",
      }}
    >
      <AnalyticsFilterItems data={data} />
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, pb: 0.5, ml: "auto" }}>
        <Tooltip title="Refresh">
          <IconButton onClick={refetch} sx={{ color: BRAND_COLOR }}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
}
